import React, { useState } from 'react';
import './AjustesPermisos.scss';
import TablaPermisos from './components/TablaPermisos/TablaPermisos';
import Ajustes from './components/Ajustes/Ajustes';
import { Button } from 'react-bootstrap';
import { ShieldCheck, PersonGear, Sliders } from 'react-bootstrap-icons';
import SettingsDelegationAdmin from './components/SettingsDelegationAdmin';
import { isFeatureRolloutLocal } from '../../../../configuration/directMenuRollout';
import { isSuperAdmin } from '../../../../utils/functions';

const AjustesPermisos: React.FC = () => {

  const [selectedView, setSelectedView] = useState<'ajustes' | 'permisos'>('ajustes');
  const localId = JSON.parse(localStorage.getItem('user') || '{}').local_id;

  return (
    <div className="settings-container">
      <div className="mp-page-header-container">
        <div className="header-content">
          <div className="title-section">
            <div>
              <h2 className='title'>Ajustes y Permisos</h2>
              <p className="subtitle">Configuración general del restaurante y gestión de permisos de usuario</p>
            </div>
          </div>
          <div className='buttons'>
            {/* Future action buttons can go here */}
          </div>
        </div>
      </div>

      <div className="mp-button-selector-page-container">
        <div className="mp-button-selector-page-selector">
          <Button 
            variant="none"
            onClick={() => setSelectedView('ajustes')}
            className={`mp-button-selector-page-button ${selectedView === 'ajustes' ? "active" : "inactive"}`}
          >
            <Sliders className="button-icon" />
            Ajustes
          </Button>
          <Button 
            variant="none"
            onClick={() => setSelectedView('permisos')}
            className={`mp-button-selector-page-button ${selectedView === 'permisos' ? "active" : "inactive"}`}
          >
            <ShieldCheck className="button-icon" />
            Permisos
          </Button>
        </div>
      </div>

      <div className="content-area">
        {selectedView === 'ajustes' && isSuperAdmin() && isFeatureRolloutLocal(localId)
          && <SettingsDelegationAdmin key={localId} localId={localId} />}
        {(selectedView === 'ajustes') && <Ajustes />}
        {(selectedView === 'permisos') && <TablaPermisos />}
      </div>
    </div>
  );
};

export default AjustesPermisos;